import {TweenMax} from 'gsap';

export class SvgLoader {

  public static init() {
    SvgLoader.load();
  }

  private static load() {
    $(function () {
      $('[data-svg]').each(function () {
        let $this = $(this);
        let imgURL = $this.data('svg');
        $.get(imgURL, function (data) {
          let $svg = $(data).find('svg');
          $svg = $svg.removeAttr('xmlns:a');
          TweenMax.set($svg, {autoAlpha: 0});
          $this.append($svg);
          $this.trigger('svgReady');
          TweenMax.to($svg, .5, {autoAlpha: 1});
        }, 'xml');
      });
    });
  }
}